// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "(max-width: 1024px) and (min-width: 601px)";
var _4 = "wrapper-1vSkb";
var _5 = "button-igdO0";
var _6 = "wrapper_square-1h7hn";
var _7 = "button_light-1CmrB";
var _8 = "button_google-12rdJ";
var _9 = "button_facebook-3I7Yc";
export { _1 as "__esModule", _2 as "mobile", _3 as "tablet_only", _4 as "wrapper", _5 as "button", _6 as "wrapper_square", _7 as "button_light", _8 as "button_google", _9 as "button_facebook" }
export default { "__esModule": _1, "mobile": _2, "tablet_only": _3, "wrapper": _4, "button": _5, "wrapper_square": _6, "button_light": _7, "button_google": _8, "button_facebook": _9 }
